'use client';
import { useViewerPlan } from '@hooks/useViewerPlan';
import { useConfig } from '@marine/configs';
import { Grid } from 'antd';
import styles from './rectangleAd.module.scss';
import SquareAd from './SquareAd';

const RectangleAd: React.FC = () => {
  const { useBreakpoint } = Grid;
  const { sm } = useBreakpoint();
  const { manageSubscriptionUrl } = useConfig();
  const { isSubscribed } = useViewerPlan();

  if (isSubscribed) {
    return null;
  }

  if (!sm) {
    return <SquareAd />;
  }

  return (
    <div style={{ padding: '0 24px' }}>
      <div className={styles.container}>
        <p className={styles.label}>Advertisement</p>

        <div className={styles.content}>
          <p className={styles.desc}>
            Hide ads, help pay for servers & development and unlock Pro only features like, sharing, advanced dashboard,
            extra storage space & more!
          </p>
        </div>
        <a href={manageSubscriptionUrl} className={styles.link}>
          Hide ads
        </a>
      </div>
    </div>
  );
};

export default RectangleAd;
